import { render, staticRenderFns } from "./AplikacjaMobilna.vue?vue&type=template&id=a195ce04&scoped=true"
import script from "./AplikacjaMobilna.vue?vue&type=script&lang=js"
export * from "./AplikacjaMobilna.vue?vue&type=script&lang=js"
import style0 from "./AplikacjaMobilna.vue?vue&type=style&index=0&id=a195ce04&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a195ce04",
  null
  
)

export default component.exports